module.exports = __webpack_public_path__ + "img/858362_9F9F80_9C9673_70714B-256px.9b1be59b.png";